/* DillySocks — Back-in-Stock Benachrichtigung.

   - Ausverkaufte GRÖSSEN bekommen einen gestrichelten Button mit Couvert +
     "Benachrichtigen"; Klick öffnet einen theme-nativen Slider (kein
     Klaviyo-Modal) mit E-Mail-Feld.
   - Ist ALLES ausverkauft, ersetzt eine "Aktuell ausverkauft"-Box die
     Grössen und bietet einen Benachrichtigungs-Button.
   - Absenden -> Klaviyo Client-API (Back-in-Stock-Subscription) für die
     gewählte Variante. Kein privater Key nötig (company_id = public key).

   Konfiguration kommt aus window.DS_BIS_CONFIG (siehe ds-back-in-stock.liquid).
*/
(function () {
  'use strict';

  var CFG = window.DS_BIS_CONFIG || {};
  var ACCOUNT = CFG.account || '';
  var REVISION = CFG.revision || '2024-10-15';
  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + ACCOUNT;

  /* Uebersetzte Texte kommen aus CFG.i18n (ds-back-in-stock.liquid, Locale-
     Keys ds_bis.*); die deutschen Strings hier sind nur noch der Fallback,
     falls das Config-Island fehlt. */
  var T = Object.assign({
    notify: 'Benachrichtigen',
    soldout: 'Aktuell ausverkauft',
    cta: 'Benachrichtige mich, sobald verfügbar',
    drawerTitle: 'Benachrichtigung',
    lead: 'Wir sagen dir Bescheid',
    sub: 'Diese Grösse ist aktuell ausverkauft. Gib deine E-Mail ein und wir benachrichtigen dich, sobald sie wieder verfügbar ist.',
    sizeLabel: 'Für welche Grösse?',
    emailLabel: 'E-Mail-Adresse',
    emailPlaceholder: 'name@beispiel.ch',
    sending: 'Wird gesendet …',
    submit: 'Benachrichtige mich',
    success: 'Perfekt! Wir melden uns, sobald es wieder verfügbar ist.',
    errEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
    errGeneric: 'Etwas ist schiefgelaufen. Bitte versuch es später erneut.',
    legal: 'Mit dem Absenden stimmst du zu, eine einmalige E-Mail-Benachrichtigung zu erhalten.',
    close: 'Schliessen'
  }, CFG.i18n || {});

  /* ---- Variantendaten aus dem Grössen-Picker lesen --------------------- */
  function readVariants(picker) {
    var out = [];
    picker.querySelectorAll('.variant-option__button-label input[data-variant-id]').forEach(function (inp) {
      var label = inp.closest('.variant-option__button-label');
      out.push({
        size: (label.querySelector('.variant-option__button-label__text') || label).textContent.trim(),
        variantId: inp.getAttribute('data-variant-id'),
        available: inp.getAttribute('data-option-available') === 'true',
        label: label,
        input: inp
      });
    });
    return out;
  }

  function productTitle() {
    var h = document.querySelector('.product-title, .product-information h1, h1');
    return h ? h.textContent.trim() : '';
  }

  /* ---- Slider (einmalig) ----------------------------------------------- */
  var els = null;
  var state = { variants: [], selected: null };

  function ensureDrawer() {
    if (els) return els;

    var scrim = document.createElement('div');
    scrim.className = 'ds-bis-scrim';

    var aside = document.createElement('aside');
    aside.className = 'ds-bis';
    aside.setAttribute('role', 'dialog');
    aside.setAttribute('aria-modal', 'true');
    aside.setAttribute('aria-label', T.drawerTitle);
    aside.innerHTML =
      '<div class="ds-bis__head">' +
      '  <h2 class="ds-bis__title">' + T.drawerTitle + '</h2>' +
      '  <button type="button" class="ds-bis__close" aria-label="' + T.close + '"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>' +
      '</div>' +
      '<div class="ds-bis__body">' +
      '  <p class="ds-bis__lead">' + T.lead + '</p>' +
      '  <p class="ds-bis__sub">' + T.sub + '</p>' +
      '  <div class="ds-bis__product" data-bis-product></div>' +
      '  <p class="ds-bis__sizeslabel" data-bis-sizeslabel>' + T.sizeLabel + '</p>' +
      '  <div class="ds-bis__sizes" data-bis-sizes></div>' +
      '  <label class="ds-bis__field"><span>' + T.emailLabel + '</span><input type="email" inputmode="email" autocomplete="email" data-bis-email placeholder="' + T.emailPlaceholder + '"></label>' +
      '  <p class="ds-bis__msg" data-bis-msg></p>' +
      '  <button type="button" class="ds-bis__submit" data-bis-submit><i class="fa-regular fa-envelope" aria-hidden="true"></i> ' + T.submit + '</button>' +
      '  <p class="ds-bis__legal">' + T.legal + '</p>' +
      '</div>';

    document.body.appendChild(scrim);
    document.body.appendChild(aside);

    scrim.addEventListener('click', close);
    aside.querySelector('.ds-bis__close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && aside.classList.contains('is-open')) close();
    });
    aside.querySelector('[data-bis-submit]').addEventListener('click', submit);

    els = { scrim: scrim, aside: aside };
    return els;
  }

  function renderSizes() {
    var wrap = els.aside.querySelector('[data-bis-sizes]');
    var label = els.aside.querySelector('[data-bis-sizeslabel]');
    wrap.innerHTML = '';
    var soldouts = state.variants.filter(function (v) { return !v.available; });
    // Nur eine ausverkaufte Grösse -> keine Auswahl nötig.
    if (soldouts.length <= 1) {
      label.style.display = 'none';
      wrap.style.display = 'none';
      return;
    }
    label.style.display = '';
    wrap.style.display = '';
    soldouts.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ds-bis__size' + (v.variantId === state.selected ? ' is-sel' : '');
      b.textContent = v.size;
      b.addEventListener('click', function () {
        state.selected = v.variantId;
        renderSizes();
      });
      wrap.appendChild(b);
    });
  }

  function open(preselectVariantId) {
    ensureDrawer();
    var soldouts = state.variants.filter(function (v) { return !v.available; });
    state.selected = preselectVariantId || (soldouts[0] && soldouts[0].variantId) || null;
    els.aside.querySelector('[data-bis-product]').textContent = productTitle();
    var msg = els.aside.querySelector('[data-bis-msg]');
    msg.className = 'ds-bis__msg';
    msg.textContent = '';
    var input = els.aside.querySelector('[data-bis-email]');
    input.value = '';
    var btn = els.aside.querySelector('[data-bis-submit]');
    btn.disabled = false;
    btn.innerHTML = '<i class="fa-regular fa-envelope" aria-hidden="true"></i> ' + T.submit;
    renderSizes();
    els.aside.classList.add('is-open');
    els.aside.setAttribute('aria-hidden', 'false');
    els.scrim.classList.add('is-open');
    setTimeout(function () { input.focus({ preventScroll: true }); }, 320);
  }

  function close() {
    if (!els) return;
    els.aside.classList.remove('is-open');
    els.aside.setAttribute('aria-hidden', 'true');
    els.scrim.classList.remove('is-open');
  }

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function submit() {
    var input = els.aside.querySelector('[data-bis-email]');
    var msg = els.aside.querySelector('[data-bis-msg]');
    var btn = els.aside.querySelector('[data-bis-submit]');
    var email = (input.value || '').trim();

    msg.className = 'ds-bis__msg';
    if (!validEmail(email)) {
      msg.className = 'ds-bis__msg is-error';
      msg.textContent = T.errEmail;
      input.focus();
      return;
    }
    if (!state.selected || !ACCOUNT) {
      msg.className = 'ds-bis__msg is-error';
      msg.textContent = T.errGeneric;
      return;
    }

    btn.disabled = true;
    btn.innerHTML = T.sending;

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + state.selected } }
        }
      }
    };

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (res.status === 202 || res.ok) {
          msg.className = 'ds-bis__msg is-success';
          msg.textContent = T.success;
          input.value = '';
          btn.innerHTML = '<i class="fa-solid fa-check" aria-hidden="true"></i> ' + T.success.split('!')[0];
          setTimeout(close, 2200);
        } else {
          throw new Error('status ' + res.status);
        }
      })
      .catch(function () {
        msg.className = 'ds-bis__msg is-error';
        msg.textContent = T.errGeneric;
        btn.disabled = false;
        btn.innerHTML = '<i class="fa-regular fa-envelope" aria-hidden="true"></i> ' + T.submit;
      });
  }

  /* ---- Grössen-Buttons anreichern -------------------------------------- */
  function markSoldSize(v) {
    if (v.label.classList.contains('ds-bis-size')) return;
    v.label.classList.add('ds-bis-size');
    var note = document.createElement('span');
    note.className = 'ds-bis-note';
    note.innerHTML = '<i class="fa-regular fa-envelope" aria-hidden="true"></i><span>' + T.notify + '</span>';
    v.label.appendChild(note);
    v.label.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      state.variants = readVariants(document.querySelector('variant-picker'));
      open(v.variantId);
    }, true);
  }

  /* ---- Komplett-Ausverkauft-Box ---------------------------------------- */
  function renderAllSoldOut(picker, variants) {
    if (document.querySelector('.ds-bis-soldout')) return;
    // Grössen-Fieldset(s) ausblenden.
    picker.querySelectorAll('.variant-option').forEach(function (f) { f.style.display = 'none'; });
    // Kaufbutton-Bereich ausblenden (Payment-Icons bleiben, eigener Block).
    document.querySelectorAll('.buy-buttons-block, accelerated-checkout, .accelerated-checkout').forEach(function (b) {
      b.style.display = 'none';
    });

    var box = document.createElement('div');
    box.className = 'ds-bis-soldout';
    box.innerHTML =
      '<div class="ds-bis-soldout__label"><i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i> ' + T.soldout + '</div>' +
      '<button type="button" class="ds-bis-soldout__cta"><i class="fa-regular fa-envelope" aria-hidden="true"></i> ' + T.cta + '</button>';
    picker.appendChild(box);
    box.querySelector('.ds-bis-soldout__cta').addEventListener('click', function () {
      state.variants = readVariants(picker);
      open(null);
    });
  }

  /* ---- Advent-PDP (Sean 29.08.): eigene Groessen-Buttons ---------------- */
  /* Die Advent-Seite (sections/ds-advent-pdp.liquid) hat keinen
     <variant-picker>; Varianten stecken im JSON-Island [data-ds-adv-data],
     die Groessen sind .ds-adv__size-Buttons (disabled = ausverkauft).
     Ausverkaufte Groessen werden klickbar (Klasse ds-bis-advsize + Couvert)
     und oeffnen denselben Drawer. Idempotent: einmal umgebaute Buttons
     werden ueber die Klasse erkannt. */
  function readAdventVariants(root) {
    var out = [];
    root.querySelectorAll('[data-ds-adv-size]').forEach(function (btn) {
      out.push({
        size: (btn.childNodes[0] && btn.childNodes[0].textContent || btn.textContent).trim(),
        variantId: btn.getAttribute('data-ds-adv-size'),
        available: !btn.disabled && !btn.classList.contains('ds-bis-advsize'),
        button: btn
      });
    });
    return out;
  }

  function enhanceAdvent(root) {
    var variants = readAdventVariants(root);
    if (!variants.length) return;
    state.variants = variants;
    var soldouts = variants.filter(function (v) { return !v.available; });

    soldouts.forEach(function (v) {
      var btn = v.button;
      if (btn.classList.contains('ds-bis-advsize')) return;
      btn.disabled = false;
      btn.classList.add('ds-bis-advsize');
      var note = document.createElement('span');
      note.className = 'ds-bis-note';
      note.innerHTML = '<i class="fa-regular fa-envelope" aria-hidden="true"></i><span>' + T.notify + '</span>';
      btn.appendChild(note);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        state.variants = readAdventVariants(root);
        open(v.variantId);
      }, true);
    });

    // BEWUSST keine zusaetzliche "Aktuell ausverkauft"-Box mehr auf der
    // Advent-PDP (Sean-Briefing 11.09., Punkt 4): die Benachrichtigung
    // laeuft ausschliesslich ueber die Couvert-Pillen an den Groessen —
    // der Status ist an der Pille selbst sichtbar.
  }

  /* ---- Enhance (idempotent, re-run nach Re-Renders) -------------------- */
  var observer = null;
  function enhance() {
    var adv = document.querySelector('[data-ds-advent]');
    if (adv) { enhanceAdvent(adv); return; }
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    var variants = readVariants(picker);
    if (!variants.length) return;
    state.variants = variants;

    var soldouts = variants.filter(function (v) { return !v.available; });
    if (soldouts.length === variants.length) {
      renderAllSoldOut(picker, variants);
    } else {
      soldouts.forEach(markSoldSize);
    }
  }

  function observe() {
    var picker = document.querySelector('variant-picker');
    if (!picker || observer) return;
    observer = new MutationObserver(function () {
      observer.disconnect();
      enhance();
      observer.observe(picker, { childList: true, subtree: true });
    });
    observer.observe(picker, { childList: true, subtree: true });
  }

  function init() {
    enhance();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
